import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function JWTDebuggerPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "JWT Debugger & Decoder",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free online JWT (JSON Web Token) debugger and decoder. Decode JWT tokens to inspect header, payload, and signature. Works completely offline with no data transmission."
  };

  return (
    <>
      <SEO
        title="JWT Debugger & Decoder - Decode JSON Web Tokens Online | JsonToonCraft"
        description="Free JWT debugger and decoder tool. Decode and inspect JWT tokens to view header, payload, and signature. Works offline, no data is stored or transmitted. 100% secure and private."
        keywords="JWT debugger, JWT decoder, JSON Web Token, decode JWT, JWT inspector, JWT parser, JWT token decoder, online JWT tool"
        canonicalUrl="https://jsontooncraft.com/dev-tools/jwt-debugger"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="jwt" />
    </>
  );
}
